"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Put your application javascript here
window.theme = window.theme || {};

(function ($) {
  "use strict";

  var config = {
    common: {
      apiUrl: 'https://api.studioitalia.com.au',
      storefrontApiUrl: '/api/2021-07/graphql.json'
    },
    mondoluce: {
      storefrontAccessToken: '8417a9536e8d3d7e4eb45452250eed42',
      site: 'MONDOLUCE'
    },
    studioItalia: {
      storefrontAccessToken: 'TODO',
      site: 'STUDIO_ITALIA'
    }
  };
  var siteConfig = window.location.hostname.includes('mondoluce') ? config.mondoluce : config.studioItalia;
  theme.ENV = $.extend(config.common, siteConfig);
  theme.utils = {
    checkLuma: function checkLuma(color) {
      var rgb = color.substring(4, color.length - 1).replace(/ /g, '').split(',');
      var luma = 0.299 * parseInt(rgb[0]) + 0.587 * parseInt(rgb[1]) + 0.114 * parseInt(rgb[2]);

      if (luma < 186) {
        return true;
      }

      return false;
    },
    uuid: function uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    setCookie: function setCookie(cname, cvalue) {
      var d = new Date();
      d.setTime(d.getTime() + 60 * 60 * 1000); //1h

      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return "";
    },
    fetch: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (url, options) {
      return new Promise(function (resolve, reject) {
        fetch(url, options).then(function (response) {
          console.log('application.js fetch', {
            response: response
          });
          response.json().then(function (data) {
            if (response.status >= 400) reject(data);else resolve(data);
          });
        })["catch"](function (error) {
          reject(error);
        });
      });
    }),
    debounce: function debounce(func) {
      var _this = this;

      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
      var timer;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        clearTimeout(timer);
        timer = setTimeout(function () {
          func.apply(_this, args);
        }, timeout);
      };
    },
    replaceUrlParam: function replaceUrlParam(url, paramName, paramValue) {
      if (paramValue == null) {
        paramValue = '';
      }

      var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');

      if (url.search(pattern) >= 0) {
        return url.replace(pattern, '$1' + paramValue + '$2');
      }

      url = url.replace(/[?#]$/, '');
      return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    }
  };
  theme.a11y = {
    trapFocus: function trapFocus(options) {
      var element = typeof options.element === 'string' ? $(options.element) : options.element;
      var elementToFocus = typeof options.elementToFocus === 'string' ? $(options.elementToFocus) : options.elementToFocus; // Get every possible visible focusable element

      var focusableEls = element.find('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(function (el) {
        return el.offsetParent !== null;
      });
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!elementToFocus) {
        elementToFocus = element;
      }

      element.attr('tabindex', '-1');
      elementToFocus.focus();
      var $document = $(document.documentElement);
      $document.off('focusin');
      $document.on('focusout', function () {
        $document.off('keydown.handleFocus');
      });
      $document.on('focusin', function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
        $document.on('keydown.handleFocus', function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */

        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function removeTrapFocus(element) {
      var el = element ? typeof element === 'string' ? $(element) : element : $(document.documentElement);
      el.removeAttr('tabindex');
      el.off('focusin');
    },
    lockScrolling: function lockScrolling(element) {
      var el = element ? typeof element === 'string' ? $(element) : element : $(document.documentElement);
      el.addClass('lock-scroll');
      el.on('touchmove', function () {
        return true;
      });
    },
    unlockScrolling: function unlockScrolling(element) {
      var el = element ? typeof element === 'string' ? $(element) : element : $(document.documentElement);
      el.removeClass('lock-scroll');
      el.off('touchmove');
    }
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function _createInstance(container, constructor) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      var instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
      this.instances.push(instance);
    },
    _onSectionLoad: function _onSectionLoad(evt) {
      var container = document.querySelector('[data-section-id="' + evt.detail.sectionId + '"]');

      if (container) {
        this._createInstance(container);
      }
    },
    _onSectionUnload: function _onSectionUnload(evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },
    _onSelect: function _onSelect(evt) {
      var instance = this.instances.find(function (instance) {
        return instance.id === evt.detail.sectionId;
      });

      if (typeof instance !== 'undefined' && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
    _onDeselect: function _onDeselect(evt) {
      var instance = this.instances.find(function (instance) {
        return instance.id === evt.detail.sectionId;
      });

      if (typeof instance !== 'undefined' && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
    _onBlockSelect: function _onBlockSelect(evt) {
      var instance = this.instances.find(function (instance) {
        return instance.id === evt.detail.sectionId;
      });

      if (typeof instance !== 'undefined' && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
    _onBlockDeselect: function _onBlockDeselect(evt) {
      var instance = this.instances.find(function (instance) {
        return instance.id === evt.detail.sectionId;
      });

      if (typeof instance !== 'undefined' && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
    register: function register(type, constructor) {
      this.constructors[type] = constructor;
      document.querySelectorAll('[data-section-type="' + type + '"]').forEach(function (container) {
        this._createInstance(container, constructor);
      }.bind(this));
    }
  });

  theme.Product = function () {
    function Product(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.zoomPictures = [];
      this.ajaxEnabled = container.getAttribute('data-ajax-enabled') === 'true';
      this.settings = {
        // Breakpoints from src/stylesheets/global/variables.scss.liquid
        mediaQueryMediumUp: 'screen and (min-width: 750px)',
        mediaQuerySmall: 'screen and (max-width: 749px)',
        bpSmall: false,
        enableHistoryState: container.getAttribute('data-enable-history-state') === 'true',
        namespace: '.slideshow-' + sectionId,
        sectionId: sectionId,
        sliderActive: false,
        zoomEnabled: false
      };
      this.selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        enquireButton: '[data-enquire-btn]',
        enquireLink: '[data-enquire-link]',
        form: '#product_form_' + sectionId,
        loader: '[data-loader]',
        quantityWrapper: '[data-quantity-wrapper]',
        quantity: '[data-quantity-input]',
        SKU: '.variant-sku',
        originalSelectorId: '#ProductSelect-' + sectionId,
        productForm: '[data-product-form]',
        errorMessage: '[data-error-message]',
        errorMessageWrapper: '[data-error-message-wrapper]',
        productMediaWrapper: '[data-product-single-media-wrapper]',
        productGallerySelector: '#product-gallery-' + sectionId,
        singleOptionSelector: ".variant-selection__input-" + sectionId,
        shopifyPaymentButton: '.shopify-payment-button',
        productAvailable: '.product__in-stock',
        priceContainer: '[data-price]',
        regularPrice: '[data-regular-price]',
        salePrice: '[data-sale-price]',
        productPolicies: '[data-product-policies]',
        storeAvailabilityContainer: '[data-store-availability-container]',
        specificationTable: "[data-product-specification]",
        addToWishlist: "[data-add-to-wishlist]"
      };
      this.classes = {
        cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
        hidden: 'hide',
        visibilityHidden: 'visibility-hidden',
        inputError: 'input--error',
        jsZoomEnabled: 'js-zoom-enabled',
        productOnSale: 'price--on-sale',
        productUnavailable: 'price--unavailable',
        productSoldOut: 'price--sold-out',
        cartImage: 'cart-popup-item__image',
        productFormErrorMessageWrapperHidden: 'product-form__error-message-wrapper--hidden',
        activeClass: 'active-thumb',
        variantSoldOut: 'product-form--variant-sold-out'
      };
      this.eventHandlers = {};
      this.quantityWrapper = container.querySelector(this.selectors.quantityWrapper);
      this.quantityInput = container.querySelector(this.selectors.quantity);
      this.errorMessageWrapper = container.querySelector(this.selectors.errorMessageWrapper);
      this.productForm = container.querySelector(this.selectors.productForm);
      this.addToCart = container.querySelector(this.selectors.addToCart);
      this.addToCartText = this.addToCart.querySelector(this.selectors.addToCartText);
      this.enquireButton = container.querySelector(this.selectors.enquireButton);
      this.enquireLink = container.querySelector(this.selectors.enquireLink);
      this.productAvailable = container.querySelector(this.selectors.productAvailable);
      this.shopifyPaymentButton = container.querySelector(this.selectors.shopifyPaymentButton);
      this.priceContainer = container.querySelector(this.selectors.priceContainer);
      this.productPolicies = container.querySelector(this.selectors.productPolicies);
      this.loader = this.addToCart.querySelector(this.selectors.loader);
      var productJson = document.getElementById('ProductJson-' + sectionId);

      if (!productJson || !productJson.innerHTML.length) {
        return;
      }

      var metafields = document.querySelectorAll('[id^=MetafieldsJson-]');
      this.metafieldsArray = _toConsumableArray(metafields).map(function (element) {
        var metafieldsObj = JSON.parse(element.innerHTML);
        console.log(metafieldsObj);
        return {
          id: element.dataset.id,
          specification: metafieldsObj.specifications,
          back_order: metafieldsObj.backorder_text,
          warranty: metafieldsObj.warranty
        };
      });
      this.productSingleObject = JSON.parse(productJson.innerHTML);
      console.log('productSingleObject');
      console.log(this.productSingleObject);
      this.productState = {
        available: true,
        soldOut: false,
        onSale: false,
        poa: false
      };

      this._stringOverrides();

      this._initSpecificationTable();

      this._initVariants();

      this._initForm(); // update spec table to hide empty rows


      this.container.dispatchEvent(new CustomEvent('variantSpecChange', {
        detail: {
          variant: this.variants.currentVariant
        },
        bubbles: true,
        cancelable: true
      }));
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      _stringOverrides: function _stringOverrides() {
        theme.productStrings = theme.productStrings || {};
        theme.strings = Object.assign({}, theme.strings, theme.productStrings);
      },
      _initSpecificationTable: function _initSpecificationTable() {
        var specificationObject = {};
        this.metafieldsArray.forEach(function (metafields) {
          if (metafields.specification) Object.keys(metafields.specification).map(function (key) {
            if (!(key in specificationObject)) {
              specificationObject[key] = {};
            }

            if (metafields.specification[key] != null && metafields.specification[key] != "") {
              specificationObject[key][metafields.id] = metafields.specification[key];
            }
          });
        });
        var specificationTable = this.container.querySelector(this.selectors.specificationTable);
        Object.keys(specificationObject).map(function (specification_key) {
          if (Object.keys(specificationObject[specification_key]).length > 0) {
            var tr = document.createElement("tr");
            var th = document.createElement("td");
            th.classList.add("attr-name");
            var name = document.createTextNode(specification_key.replace("-", " ").replace("_", " ").replace('ip', 'IP').replace('cri', 'CRI'));
            th.appendChild(name);
            tr.appendChild(th);
            var td = document.createElement("td");
            Object.keys(specificationObject[specification_key]).map(function (variant_id) {
              var span = document.createElement("span");
              span.classList.add("attr-value");
              span.dataset.id = variant_id;
              var content = document.createTextNode(specificationObject[specification_key][variant_id]);
              span.appendChild(content);
              td.appendChild(span);
            });
            tr.appendChild(td);
            specificationTable.appendChild(tr);
          }
        }); // append weight to table

        if (this.productSingleObject.variants[0].weight) {
          var tr = document.createElement("tr");
          var th = document.createElement("td");
          th.classList.add("attr-name");
          var name = document.createTextNode('Weight');
          th.appendChild(name);
          tr.appendChild(th);
          var td = document.createElement("td");
          this.productSingleObject.variants.forEach(function (variant) {
            if (variant.weight) {
              var span = document.createElement("span");
              span.classList.add("attr-value");
              span.dataset.id = variant.id;
              var content = document.createTextNode((variant.weight / 1000.00).toFixed(2) + 'Kg');
              span.appendChild(content);
              td.appendChild(span);
            }
          });
          tr.appendChild(td);
          specificationTable.appendChild(tr);
        }

        if (this.metafieldsArray[0].warranty) {
          var tr = document.createElement("tr");
          var th = document.createElement("td");
          th.classList.add("attr-name");
          var name = document.createTextNode('Warranty');
          th.appendChild(name);
          tr.appendChild(th);
          var td = document.createElement("td");
          var span = document.createElement("span");
          var content = document.createTextNode(this.metafieldsArray[0].warranty);
          span.appendChild(content);
          td.appendChild(span);
          tr.appendChild(td);
          specificationTable.appendChild(tr);
        }
      },
      _initForm: function _initForm() {
        this.container.querySelector(this.selectors.form).addEventListener('submit', this._handleAddToCart.bind(this));
      },
      _handleAddToCart: function _handleAddToCart(event) {
        var self = this;
        event.preventDefault();
        var formData = new FormData(document.querySelector('.product-form'));
        var id = "";
        var quantity = 0;
        var _stockMsg = "";

        var _iterator = _createForOfIteratorHelper(formData.entries()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pair = _step.value;

            if (pair[0] === "id") {
              id = pair[1];
            }

            if (pair[0] === "quantity") {
              quantity = pair[1];
            }

            if (pair[0] === "properties[_stockMsg]") {
              _stockMsg = pair[1];
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var properties = {
          _stockMsg: _stockMsg
        };

        self._disableAddToCart("Adding to cart..", false, false);

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: [{
              id: id,
              quantity: quantity,
              properties: properties
            }]
          })
        }).then(function (response) {
          return response.json().then(function (data) {
            if (response.ok) return data;
            throw Error(data.description);
          });
        }).then(function (data) {
          updateCartBadge();

          self._enableAddToCart("Added");

          setTimeout(function () {
            self._updateAddToCart();
          }, 2000);
        })["catch"](function (error) {
          self._enableAddToCart("Add to Cart");

          $("[data-error-message]").text(error.message).show();
          setTimeout(function () {
            $("[data-error-message]").text("").hide();
          }, 2000);
        });
      },
      _initVariants: function _initVariants() {
        var options = {
          container: this.container,
          enableHistoryState: this.container.getAttribute('data-enable-history-state') === 'true',
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          product: this.productSingleObject
        };
        this.variants = new theme.Variants(options);
        this.eventHandlers.updateAvailability = this._updateAvailability.bind(this);
        this.eventHandlers.updateMedia = this._updateMedia.bind(this);
        this.eventHandlers.updatePrice = this._updatePrice.bind(this);
        this.eventHandlers.updateSpecTable = this._updateSpecTable.bind(this);
        this.eventHandlers.updateSKU = this._updateSKU.bind(this);
        this.container.addEventListener('variantChange', this.eventHandlers.updateAvailability);
        this.container.addEventListener('variantImageChange', this.eventHandlers.updateMedia);
        this.container.addEventListener('variantPriceChange', this.eventHandlers.updatePrice);
        this.container.addEventListener('variantSKUChange', this.eventHandlers.updateSKU);
        this.container.addEventListener('variantSpecChange', this.eventHandlers.updateSpecTable);
      },
      _handleButtonLoadingState: function _handleButtonLoadingState(isLoading) {
        if (isLoading) {
          this.addToCart.setAttribute('aria-disabled', true);
          this.addToCartText.classList.add(this.classes.hidden);
          this.loader.classList.remove(this.classes.hidden);

          if (this.shopifyPaymentButton) {
            this.shopifyPaymentButton.setAttribute('disabled', true);
          }
        } else {
          this.addToCart.removeAttribute('aria-disabled');
          this.addToCartText.classList.remove(this.classes.hidden);
          this.loader.classList.add(this.classes.hidden);

          if (this.shopifyPaymentButton) {
            this.shopifyPaymentButton.removeAttribute('disabled');
          }
        }
      },
      _showErrorMessage: function _showErrorMessage(errorMessage) {
        var errorMessageContainer = this.container.querySelector(this.selectors.errorMessage);
        errorMessageContainer.innerHTML = errorMessage;

        if (this.quantityInput) {
          this.quantityInput.classList.add(this.classes.inputError);
        }

        this.errorMessageWrapper.classList.remove(this.classes.productFormErrorMessageWrapperHidden);
        this.errorMessageWrapper.setAttribute('aria-hidden', true);
        this.errorMessageWrapper.removeAttribute('aria-hidden');
      },
      _hideErrorMessage: function _hideErrorMessage() {
        this.errorMessageWrapper.classList.add(this.classes.productFormErrorMessageWrapperHidden);

        if (this.quantityInput) {
          this.quantityInput.classList.remove(this.classes.inputError);
        }
      },
      _getVariantOptionList: function _getVariantOptionList(variantOptions) {
        var variantOptionListHTML = '';
        variantOptions.forEach(function (variantOption) {
          variantOptionListHTML = variantOptionListHTML + '<li class="product-details__item product-details__item--variant-option">' + variantOption.name + ': ' + variantOption.value + '</li>';
        });
        return variantOptionListHTML;
      },
      _switchMedia: function _switchMedia(mediaId) {
        var newMedia = this.container.querySelector(this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']");
        var index = newMedia.dataset.index;
        var gallery = $(this.selectors.productGallerySelector);
        gallery.trigger('to.owl.carousel', [index, 1]);
      },
      _enableAddToCart: function _enableAddToCart(message) {
        this.addToCart.removeAttribute('aria-disabled');
        this.addToCart.setAttribute('aria-label', message);
        this.addToCartText.innerHTML = message;
        this.productForm.classList.remove(this.classes.variantSoldOut);
        this.productAvailable.classList.remove(this.classes.hidden);
        this.enquireLink.classList.remove(this.classes.hidden);
        this.quantityWrapper.classList.remove(this.classes.hidden);
        this.addToCart.classList.remove(this.classes.hidden);
        this.enquireButton.classList.add(this.classes.hidden);
      },
      _disableAddToCart: function _disableAddToCart(message, hideAvailablility, enquireOnly) {
        message = message || theme.strings.unavailable;
        this.addToCart.setAttribute('aria-disabled', true);
        this.addToCart.setAttribute('aria-label', message);
        this.addToCartText.innerHTML = message;
        this.productForm.classList.add(this.classes.variantSoldOut);
        hideAvailablility && this.productAvailable.classList.add(this.classes.hidden);

        if (enquireOnly) {
          this.enquireLink.classList.add(this.classes.hidden);
          this.quantityWrapper.classList.add(this.classes.hidden);
          this.addToCart.classList.add(this.classes.hidden);
          this.enquireButton.classList.remove(this.classes.hidden);
        } else {
          this.enquireLink.classList.remove(this.classes.hidden);
          this.quantityWrapper.classList.remove(this.classes.hidden);
          this.addToCart.classList.remove(this.classes.hidden);
          this.enquireButton.classList.add(this.classes.hidden);
        }
      },
      _updateAddToCart: function _updateAddToCart() {
        if (!this.productState.available) {
          this._disableAddToCart(theme.strings.unavailable, true, false);

          return;
        }

        if (this.productState.poa) {
          this._disableAddToCart("POA", true, true);

          return;
        }

        if (this.productState.soldOut) {
          this._disableAddToCart(theme.strings.soldOut, true, false);

          return;
        }

        this._enableAddToCart(theme.strings.addToCart);
      },
      _setProductState: function _setProductState(evt) {
        var variant = evt.detail.variant;

        if (!variant) {
          this.productState.available = false;
          return;
        }

        this.productState.available = true;
        this.productState.soldOut = !variant.available;
        this.productState.onSale = variant.compare_at_price > variant.price;
        this.productState.poa = this.productSingleObject.tags.includes('poa') || variant.price == 0 || variant.price == 99999900 || theme.ENV.site == 'STUDIO_ITALIA';
      },
      _updateAvailability: function _updateAvailability(evt) {
        // remove error message if one is showing
        this._hideErrorMessage(); // set product state


        this._setProductState(evt); // update form submit


        this._updateAddToCart();

        this._updatePriceComponentStyles(evt);
      },
      _updateMedia: function _updateMedia(evt) {
        var variant = evt.detail.variant;
        var mediaId = variant.featured_media.id;

        this._switchMedia(mediaId);
      },
      _hidePriceComponent: function _hidePriceComponent() {
        this.priceContainer.classList.add(this.classes.productUnavailable);
        this.priceContainer.setAttribute('aria-hidden', true);

        if (this.productPolicies) {
          this.productPolicies.classList.add(this.classes.visibilityHidden);
        }
      },
      _updatePriceComponentStyles: function _updatePriceComponentStyles(evt) {
        console.log('_updatePriceComponentStyles');
        var variant = evt.detail.variant;
        if (this.productState.poa) return;
        console.log('this.productState', _objectSpread({}, this.productState));

        if (!this.productState.available) {
          this._hidePriceComponent();

          return;
        }

        $(".variant-stock-state").hide();
        $("[data-stock-variant='" + variant.id + "']").show();
        var stockMsg = $("#stock-" + variant.id).data('stock-msg');
        $("#stockMsg").val(stockMsg); // OUT_OF_STOCK_CHANGES

        if (window.location.hostname.includes('mondoluce')) {
          this.productAvailable.classList.remove(this.classes.hidden);
        }

        if (this.productState.soldOut) {
          this.priceContainer.classList.add(this.classes.productSoldOut); // OUT_OF_STOCK_CHANGES

          if (window.location.hostname.includes('mondoluce')) {
            var quantity = this.container.querySelector("#product-form-quantity-button");
            quantity.classList.add('hide');
            var order = this.container.querySelector("#product-form-button-order");
            order.classList.add('hide');
            var enquire = this.container.querySelector("#product-form-button-enquire");
            enquire.classList.remove('hide');
          }
        } else {
          this.priceContainer.classList.remove(this.classes.productSoldOut); // OUT_OF_STOCK_CHANGES

          if (window.location.hostname.includes('mondoluce')) {
            var _quantity = this.container.querySelector("#product-form-quantity-button");

            _quantity.classList.remove('hide');

            var _order = this.container.querySelector("#product-form-button-order");

            _order.classList.remove('hide');

            var _enquire = this.container.querySelector("#product-form-button-enquire");

            _enquire.classList.add('hide');
          }
        }

        if (this.productState.onSale) {
          this.priceContainer.classList.add(this.classes.productOnSale);
        } else {
          this.priceContainer.classList.remove(this.classes.productOnSale);
        }

        this.priceContainer.classList.remove(this.classes.productUnavailable);
        this.priceContainer.removeAttribute('aria-hidden');

        if (this.productPolicies) {
          this.productPolicies.classList.remove(this.classes.visibilityHidden);
        }
      },
      _updatePrice: function _updatePrice(evt) {
        var variant = evt.detail.variant;
        var regularPrices = this.priceContainer.querySelectorAll(this.selectors.regularPrice);
        var salePrice = this.priceContainer.querySelector(this.selectors.salePrice);

        var formatRegularPrice = function formatRegularPrice(regularPriceElement, price, availableInStore) {
          var poaText = '';

          if (availableInStore) {
            if (theme.ENV.site == 'STUDIO_ITALIA') {
              poaText = '<br/><b><a href="https://www.studioitalia.com.au/pages/where-to-buy">Find stockist</a></b>';
            } else {
              poaText = '<br/><b>Available to order in store</b>';
            }
          }

          if (theme.ENV.site == 'STUDIO_ITALIA') {
            regularPriceElement.innerHTML = 'Price on application' + poaText;
          } else {
            regularPriceElement.innerHTML = theme.Currency.formatMoney(price, theme.moneyFormat) + poaText;
          }
        };

        var poa = this.productState.poa;

        if (poa) {
          regularPrices.forEach(function (regularPrice) {
            formatRegularPrice(regularPrice, variant.price, poa);
          });
        } else if (this.productState.onSale) {
          // On sale
          regularPrices.forEach(function (regularPrice) {
            formatRegularPrice(regularPrice, variant.compare_at_price);
          });
          salePrice.innerHTML = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
        } else {
          // Regular price
          regularPrices.forEach(function (regularPrice) {
            formatRegularPrice(regularPrice, variant.price, poa);
          });
        }
      },
      _updateSKU: function _updateSKU(evt) {
        var variant = evt.detail.variant; // Update the sku

        var sku = document.querySelector(this.selectors.SKU);
        if (!sku) return;
        sku.innerHTML = variant.sku;
        if (this.enquireButton) this.enquireButton.href = theme.utils.replaceUrlParam(this.enquireButton.href, 'sku', encodeURIComponent(sku.innerText));
      },
      _updateSpecTable: function _updateSpecTable(evt) {
        var variant = evt.detail.variant;
        $(".dimension-image--multiple").hide();
        $(".attr-value").hide();
        $("[data-id=" + variant.id + "]").show();
        variant.options.forEach(function (value, index) {
          $("[data-attr-index=" + index + "] [data-attr-value='" + value + "']").show();
        });
        var rows = $(".product__spec__table tbody tr");
        rows.each(function (i, element) {
          var variantValues = $(element).find('td:last-of-type span[data-id].attr-value');
          var match = null;
          var currentVariantId = "".concat(variant.id);
          variantValues.each(function (i, element) {
            var valueId = element && element.dataset && element.dataset.id;

            if (currentVariantId === valueId) {
              match = true;
            }
          });

          if (variantValues && variantValues.length > 0 && !match) {
            // hide row if there are no values for the current variant
            $(element).hide();
          }
        });
      },
      onUnload: function onUnload() {
        this.container.removeEventListener('variantChange', this.eventHandlers.updateAvailability);
        this.container.removeEventListener('variantImageChange', this.eventHandlers.updateMedia);
        this.container.removeEventListener('variantPriceChange', this.eventHandlers.updatePrice);
        this.container.removeEventListener('variantSKUChange', this.eventHandlers.updateSKU);
        this.container.removeEventListener('variantSpecChange', this.eventHandlers.updateSpecTable);
        theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
        theme.ProductModel.removeSectionModels(this.settings.sectionId);

        if (this.mqlSmall) {
          this.mqlSmall.removeListener(this.initMobileBreakpoint);
        }

        if (this.mqlMediumUp) {
          this.mqlMediumUp.removeListener(this.initDesktopBreakpoint);
        }
      }
    });
    return Product;
  }();

  theme.Currency = function () {
    var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;

        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;

        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;

        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;

        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;

        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    return {
      formatMoney: formatMoney
    };
  }();

  theme.Variants = function () {
    /**
    * Variant constructor
    *
    * @param {object} options - Settings from `product.js`
    */
    function Variants(options) {
      this.container = options.container;
      this.product = options.product;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.singleOptions = this.container.querySelectorAll(options.singleOptionSelector);
      this.currentVariant = this._getVariantFromOptions();
      $("[data-id=" + this.currentVariant.id + "]").show();
      $("[data-stock-variant='" + this.currentVariant.id + "']").show();
      this.singleOptions.forEach(function (option) {
        option.addEventListener('change', this._onSelectChange.bind(this));
      }.bind(this));
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function _getCurrentOptions() {
        var result = [];
        this.singleOptions.forEach(function (option) {
          var type = option.getAttribute('type');
          var isRadioOrCheckbox = type === 'radio' || type === 'checkbox';

          if (!isRadioOrCheckbox || option.checked) {
            result.push({
              value: option.value,
              index: option.getAttribute('data-index')
            });
          }
        });
        return result;
      },

      /**
       * Find variant based on selected values.
       *
       * @param  {array} selectedValues - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function _getVariantFromOptions() {
        var selectedValues = this._getCurrentOptions();

        var variants = this.product.variants;
        var found = variants.find(function (variant) {
          return selectedValues.every(function (values) {
            return variant[values.index] === values.value;
          });
        });
        return found;
      },

      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function _onSelectChange() {
        var variant = this._getVariantFromOptions();

        this.container.dispatchEvent(new CustomEvent('variantChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        }));

        if (!variant) {
          return;
        }

        $("#product-spec-sheet").attr('href', theme.ENV.apiUrl + '/product/spec-sheet/' + variant.id);

        this._updateMasterSelect(variant);

        this._updateImages(variant);

        this._updatePrice(variant);

        this._updateSKU(variant);

        this._updateSpecTable(variant);

        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
      _updateSpecTable: function _updateSpecTable(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantSpecChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        }));
      },

      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function _updateImages(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        }));
      },

      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function _updatePrice(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        }));
      },

      /**
       * Trigger event when variant sku changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantSKUChange
       */
      _updateSKU: function _updateSKU(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        }));
      },

      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function _updateHistoryState(variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({
          path: newurl
        }, '', newurl);
      },

      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function _updateMasterSelect(variant) {
        var masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;
        masterSelect.value = variant.id;
      }
    });
    return Variants;
  }();

  theme.Wishlist = function () {
    function Wishlist() {
      var self = this;
      this.addToWishlistButtons = $('[data-add-to-wishlist]');
      this.wishlistButton = document.getElementById('header__icon--bookmark');
      this.qtyBadge = document.getElementById('bookmark-qty');
      this.guestId = window.localStorage.getItem('WISHLIST_GUEST_ID');

      if (!(window.customer && window.customer.email) && (!this.guestId || this.guestId == 'undefined')) {
        this.guestId = theme.utils.uuid();
        window.localStorage.setItem('WISHLIST_GUEST_ID', this.guestId);
      }

      if (this.wishlistButton) {
        window.wishlist = null;
        this.guestEmail = this.guestId + '@wishlist.' + window.location.hostname;

        this._fetchWishlist();

        this.addToWishlistButtons.on('click', function (evt) {
          evt.stopPropagation();
          evt.preventDefault();
          if (this.isFetching) return;

          self._addToWishlist(evt);
        });
      }
    }

    Wishlist.prototype = Object.assign({}, Wishlist.prototype, {
      _fetchWishlist: function _fetchWishlist() {
        var self = this;
        var email = window.customer && window.customer.email || this.guestEmail;
        var url = theme.ENV.apiUrl + "/wishlist?site=" + theme.ENV.site;

        if (this.guestId && this.guestEmail && window.customer && window.customer.email) {
          url += "&email=" + email + "&guestId=" + this.guestEmail;
          window.localStorage.removeItem('WISHLIST_GUEST_ID');
        } else {
          url += "&email=" + email;
        }

        return fetch(url).then(function (response) {
          return response.json();
        }).then(function (wishlist) {
          window.wishlist = wishlist;

          self._updateAddToWishlistButtons();

          self._updateWishlistButton();
        })["catch"](function (err) {
          console.error(err);
        });
      },
      _addToWishlist: function _addToWishlist(evt) {
        var self = this;
        var product = evt.currentTarget.dataset.productId;
        var isRemove = evt.currentTarget.classList.contains('active');
        var isAddOnly = evt.currentTarget.classList.contains('add-only');
        var email = window.customer && window.customer.email || this.guestEmail;
        var data = {
          email: email,
          productId: product,
          site: theme.ENV.site
        }; // if the button is add only, and isRemove is true, the item is already on the wishlist and doesnt need to be updated

        if (isRemove && isAddOnly) return;
        fetch(theme.ENV.apiUrl + '/wishlist', {
          method: isRemove ? 'DELETE' : 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        }).then(function (response) {
          return response.json();
        }).then(function (wishlist) {
          window.wishlist = wishlist;
        })["catch"](function (err) {
          window.wishlist = null;
        })["finally"](function () {
          self._updateAddToWishlistButtons();

          self._updateWishlistButton();
        });
      },
      _updateAddToWishlistButtons: function _updateAddToWishlistButtons() {
        var self = this;

        if (!window.wishlist) {
          this._fetchWishlist().then(self._updateAddToWishlistButtons);

          return;
        }

        this.addToWishlistButtons.each(function (index, button) {
          var productId = button.dataset.productId;
          var isWishlist = window.wishlist && window.wishlist.products && window.wishlist.products.find(function (product) {
            if (product.shopifyId == productId) return true;
          });

          if (isWishlist) {
            button.classList.add('active');

            if (button.classList.contains('text')) {
              button.innerHTML = "Remove Bookmark";
            }
          } else {
            button.classList.remove('active');

            if (button.classList.contains('text')) {
              button.innerHTML = "Bookmark Product";
            }
          }
        });
      },
      _updateWishlistButton: function _updateWishlistButton() {
        var qty = window.wishlist && window.wishlist.products && window.wishlist.products.length || 0;
        this.qtyBadge.innerHTML = qty;
        this.qtyBadge.classList.toggle('hide', qty == 0);
        this.wishlistButton.classList.toggle('active', qty > 0);
      },
      _updateWishlist: function _updateWishlist() {}
    });
    return Wishlist;
  }();

  theme._initWishlist = function () {
    this.wishlist = new theme.Wishlist();
  };

  $(function () {
    theme.sections = new theme.Sections();
    theme.sections.register("product", theme.Product);

    theme._initWishlist();
  });
})(jQuery);
/* Disclosure */


$(function () {
  var selectors = {
    openButton: '.disclosure__open-button',
    openButtonLink: '.disclosure__open-button a'
  };

  function init() {
    $(selectors.openButton).on('click', handleToggle);
  }

  function destroy() {
    $(selectors.openButton).off('click', handleToggle);
  }

  $(selectors.openButtonLink).on('click', handleChildClick);

  function handleToggle(event) {
    console.log('handleToggle');
    var ANIMATION_DURATION_MS = 200;
    var body = $(event.currentTarget).next();
    var isOpening = body.is(':hidden');
    body.slideToggle(ANIMATION_DURATION_MS);
    $(event.currentTarget).find('.icon').toggleClass('rotate-180');

    if (isOpening) {
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      /* Only control scroll if on mobile */

      if (!isMobile) return;
      /* Once the dropdown animation is finished, scroll what was just clicked into view. */

      setTimeout(function () {
        event.currentTarget.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }, ANIMATION_DURATION_MS);
    }
  }

  function handleChildClick(event) {
    /* prevent links inside the button from opening the disclosure */
    event.stopPropagation();
  }

  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', destroy);
});
/* Where to Buy filtering */

$(function () {
  var selectors = {
    filters: '.where-to-buy-header .where-to-buy__filters .where-to-buy__filter',
    sections: '.where-to-buy',
    rows: '.where-to-buy .where-to-buy__row'
  };
  $(selectors.filters).on('click', handleClickFilter);

  function handleClickFilter(event) {
    console.log('handleClickFilter');
    $(selectors.filters).css('font-weight', 'normal');
    $(event.currentTarget).css('font-weight', 'bold');
    var selectedType = event.currentTarget && event.currentTarget.dataset && event.currentTarget.dataset.whereToBuyState;
    $(selectors.sections).each(function (index, element) {
      var sectionType = element.dataset.whereToBuyState;

      if (selectedType === sectionType || selectedType === 'where-to-buy-state__all') {
        $(element).show();
      } else {
        $(element).hide();
      }
    }); // $(selectors.rows).each(function (index, element) {
    //   if (selectedType === sectionType || selectedType === 'where-to-buy-state__all') {
    //     $(element).show()
    //   }
    //   else {
    //     $(element).hide()
    //   }
    // })
  }
});